
import { BaseService } from "../../BaseService";
import { NoseurObject } from "@rivtn/noseur";
import { IAdministrator } from "./AdministrationService";

export interface IPlatform {
    name: string;
    platform_id: string;
    external_id: string;
    bacuator_route: string;
    support_enabled: boolean;
    bacuator_data: {
        name: string;
        location: string;
        log_urls: string[];
        description: string;
        api_base_url: string;
        icon_location: string;
        download_counts: string;
        health_endpoint: string;
        service_api_name: string;
        users: NoseurObject<any>;
        earnings: NoseurObject<any>;
        database_query_route: string;
        database_multiple_query_route: string;
        [key:string]: any;
    };
    __internal_relay__: any;
}

export interface IPlatformAdministrator {
    platform: IPlatform;
    external_id?: string;
    administrator: IAdministrator;
}

export class PlatformService extends BaseService {

    protected static instance: PlatformService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!PlatformService.instance) PlatformService.instance = new PlatformService();
        return PlatformService.instance;
    }

    queryPlatforms(params: NoseurObject<string | number> = { page: 1, size: 10 }, refresh: boolean = false): Promise<any> {
        return this.report(this.transport.get("/janus/geminus/api/v1/platform", { query: this.normalizeParams(params),/* cache: true,*/ refreshCache: refresh } as any));
    }

    getSinglePlatform(externalId: string): Promise<any> {
        return this.report(this.transport.get(`/janus/geminus/api/v1/platform/platform_id/${externalId}`));
    }

    createPlatform(platform: IPlatform): Promise<any> {
        return this.report(this.transport.post(`/janus/geminus/api/v1/platform`, platform, this.config));
    }

    updatePlatform(platform: IPlatform): Promise<any> {
        return this.report(this.transport.patch(`/janus/geminus/api/v1/platform/${platform.external_id!}`, platform, this.config));
    }

    togglePlatformSupport(platform: IPlatform): Promise<any> {
        return this.report(this.transport.put(`/janus/geminus/api/v1/platform/${platform.external_id!}/support/${!platform.support_enabled}`, {}, this.config));
    }

    queryPlatformAdministrators(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/janus/geminus/api/v1/platform/administrator", { query: this.normalizeParams(params) }));
    }

    assignAdministratorPlatforms(platformId: string, added_administrator_ids: string[], removed_administrator_ids: string[]): Promise<any> {
        return this.report(this.transport.post(`/janus/geminus/api/v1/platform/administrator/multiple`, [
            { assign: true, platform_id: platformId, administrator_ids: added_administrator_ids },
            { assign: false, platform_id: platformId, administrator_ids: removed_administrator_ids },
        ] as any, this.config));
    }

    checkHealth(healthEndpoint: string, refresh: boolean = false): Promise<any> {
        return this.report(this.transport.get(healthEndpoint, { /* cache: true,*/ refreshCache: refresh } as any));
    }

    executeDatabaseQueries(queryEndpoint: string, payload: NoseurObject<any>): Promise<any> {
        return this.report(this.transport.post(queryEndpoint, payload, this.config));
    }

}

